export const useUserId = () => {
    const user = JSON.parse(localStorage.getItem("user")) || { userId: null };

    return { userId: user.id }
}